import axios from 'axios';
import { getCookie } from 'utils/cookie';

export const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    common: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
    },
  },
  // validateStatus: function (status) {
  //   return status < 500; // Resolve only if the status code is less than 500
  // }
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    const token = getCookie('token');
    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  },
  (error) => {
    Promise.reject(error);
  },
);
